import type { RouteRecordRaw } from 'vue-router'

import { routeDeliveryNotesRoot } from './deliveryNoteRoutes'
import { routeProjectsHome, routeProjectsRoot } from './projectRoutes'
import { routeTasksRoot } from './taskRoutes'
import { routeTimesheetsRoot } from './timesheetRoutes'

const routeProjectHome: RouteRecordRaw = {
  name: 'project-home',
  path: '',
  redirect: routeProjectsHome,
}

const routeProjectRoot: RouteRecordRaw = {
  children: [
    routeProjectHome,
    routeProjectsRoot,
    routeDeliveryNotesRoot,
    routeTimesheetsRoot,
    routeTasksRoot,
  ],
  path: 'project',
}

export { routeProjectHome, routeProjectRoot }
